import { FC } from 'react';

import LayerIcon from '@/assets/layer.svg?react';
import { FormControl, FormField, FormItem } from '@/components/ui/Form';

import { PLOT_TYPE, type PlotType } from '../schema';
import PlotOptionCard from './layout/PlotOptionCard';
import SectionHeader from './SectionHeader';
import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const PLOT_TYPE_NAME = 'plot_type';

interface Props {
  name?: string;
}

const RadioGroupPlotType: FC<Props> = ({ name = PLOT_TYPE_NAME }) => {
  const { i18n } = useLingui();
  const { control, trigger } = useFormContext();

  const plotTypeOptions: { value: PlotType; label: string }[] = [
    { value: PLOT_TYPE.AGRICULTURAL, label: i18n.t('Rolna') },
    {
      value: PLOT_TYPE.RESIDENTIAL_BUILDING,
      label: i18n.t('Budowlana mieszkaniowa'),
    },
    { value: PLOT_TYPE.SERVICE_BUILDING, label: i18n.t('Budowlana usługowa') },
    { value: PLOT_TYPE.INDUSTRIAL, label: i18n.t('Przemysłowa') },
    { value: PLOT_TYPE.FOREST, label: i18n.t('Leśna') },
    { value: PLOT_TYPE.NO_MPZP, label: i18n.t('Brak MPZP') },
    { value: PLOT_TYPE.UNKNOWN, label: i18n.t('Nie wiem') },
  ];

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        validate: (value) => !!value || i18n.t('Wybierz typ działki'),
      }}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <FormItem className="rounded-md bg-gray-200 p-[14px] md:p-6">
          <SectionHeader
            icon={LayerIcon}
            label={i18n.t('Jaki to rodzaj działki?')}
          />
          <FormControl>
            <div className="grid grid-cols-1 gap-2 md:gap-3 lg:grid-cols-2">
              {plotTypeOptions.map((opt) => (
                <PlotOptionCard
                  key={opt.value}
                  label={opt.label}
                  checked={value === opt.value}
                  type="radio"
                  onClick={() => {
                    onChange(opt.value);
                    trigger(name);
                  }}
                />
              ))}
            </div>
          </FormControl>
          {error && (
            <p className="caption-large text-red-400">{error.message}</p>
          )}
        </FormItem>
      )}
    />
  );
};

export default RadioGroupPlotType;
